// extracted by mini-css-extract-plugin
export default {"travelocity_home_page":"Home_travelocity_home_page__5SyXA","Home_make_some_space":"Home_Home_make_some_space__N1Z++"};